import Vue from 'vue'
import common from './common'
import vClickOutside from 'v-click-outside'
import vTooltip from 'v-tooltip'
import '../plugins/_vTooltip.scss'
import roomApiPlugin from '@/plugins/RoomApiPlugin'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import VueLazyload from 'vue-lazyload'
import resize from "vue-element-resize-detector";
import '@/plugins/tailwindcss';
import '@/plugins/vuedraggable';
import '@/plugins/vue-draggable-resizable';

const vTooltipOptions = {
    defaultDelay: { show: 100, hide: 100 },
}

Vue.use(common)
Vue.use(vClickOutside)
Vue.use(vTooltip, vTooltipOptions)
Vue.use(roomApiPlugin)
Vue.use(PerfectScrollbar)
Vue.use(resize)

const defaultImgUrl = require('@/assets/roomType/lms/img/v-img/noimg-user.svg');
Vue.use(VueLazyload, {
    lazyComponent: true,
    observer: true,
    placeholder: defaultImgUrl,
    loading: defaultImgUrl,
    error: defaultImgUrl,
    throttleWait: 1000,
    attempt: 1
})